

import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as searchActions from '../actions/search';
import {
    UncontrolledButtonDropdown, DropdownToggle, DropdownItem,
    DropdownMenu, Input, CustomInput, Form, FormGroup, Label
} from 'reactstrap';
import { PrivateListingPopover } from './infoPopover';
import Select from '../components/select';
import { getSizes } from '../components/utils';
import arrowDown from '../images/icons/chevron-down.svg';
import DatePickerInput from './DatePickerInput';

const SearchFilters = (props) => {
    const resetSearch = useSelector(state => state.search.resetSearch);
    const {
        listings,
        searchFilters,
        searchConfig,
        propertyType,
        mustHaves,
        onMultiSelectChange,
        handleInputChange,
        handleSaleOrLeaseChange,
        handleCheckBoxRadioChange,
        getDDFilterOptions,
        getSingleSelectCheckBoxList
    } = props;

    const { underLandscapeTablet } = getSizes();
    const dispatch = useDispatch();
    const bedsBathsOptions = ['No min', '1', '2', '3', '4', '5', '6'];

    const setFilterObjVal = (searchFilters, name, value, type) => {
        switch (type) {
            case 'int':
                searchFilters[name] = parseInt(value, 10);
                break;
            case 'bool':
                searchFilters[name] =
                    (value.toLowerCase() === "true" || value.toLowerCase() === "yes") ? true : false;
                break;
            case 'str':
                searchFilters[name] = value;
                break;
            case 'keywords':
                searchFilters[name] = value.split(",");
                break;
            default:
                searchFilters[name] = value;
        }
    }

    const handleFilterChange = (name, value, type) => {
        let parameters = Object.assign({}, searchFilters.Criteria);
        if (!value || value === '' || ['No max', 'No min'].includes(value))
            delete parameters[name];
        else
            setFilterObjVal(parameters, name, value, type || '')

        dispatch(searchActions.updateSearchFilters(Object.assign({}, searchFilters, { Criteria: parameters })));
    }

    const forSaleDropdowns = () => <>
        <div className="text-label">Price</div>
        <div className="filter_mincontrol">
            <span className="label_value dyna-form">
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.minForSale && searchFilters.Criteria.minForSale !== "") ?
                                searchFilters.Criteria.minForSale : "Min Price"}
                            </span>
                            <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        {getDDFilterOptions(searchConfig, 'minForSale', 'PropertyDetails')}
                    </UncontrolledButtonDropdown>
                </div>
            </span>
            <span className="label_text">to</span>
            <span className="label_value dyna-form">
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.maxForSale && searchFilters.Criteria.maxForSale !== "") ?
                                searchFilters.Criteria.maxForSale : "Max Price"}
                            </span>
                            <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        {getDDFilterOptions(searchConfig, 'maxForSale', 'PropertyDetails')}
                    </UncontrolledButtonDropdown>
                </div>
            </span>
        </div>
    </>

    const commercialDropdowns = () => <>
        <div className="text-label">Price</div>
        <div className="filter_mincontrol">
            <span className="label_value dyna-form">
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.minCommercial && searchFilters.Criteria.minCommercial !== "") ?
                                searchFilters.Criteria.minCommercial : "Min Price"}
                            </span>
                            <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        {getDDFilterOptions(searchConfig, 'minCommercial', 'PropertyDetails')}
                    </UncontrolledButtonDropdown>
                </div>
            </span>
            <span className="label_text">to</span>
            <span className="label_value dyna-form">
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.maxCommercial && searchFilters.Criteria.maxCommercial !== "") ?
                                searchFilters.Criteria.maxCommercial : "Max Price"}
                            </span>
                            <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        {getDDFilterOptions(searchConfig, 'maxCommercial', 'PropertyDetails')}
                    </UncontrolledButtonDropdown>
                </div>
            </span>
        </div>
    </>

    const forRentDropdowns = () => <>
        <div className="text-label">Rent</div>
        <div className="filter_mincontrol">
            <span className="label_value dyna-form">
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.minRent && searchFilters.Criteria.minRent !== "") ?
                            searchFilters.Criteria.minRent : "Min Rent"}
                            </span>
                            <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        {getDDFilterOptions(searchConfig, 'minRent', 'PropertyDetails')}
                    </UncontrolledButtonDropdown>
                </div>
            </span>
            <span className="label_text">to</span>
            <span className="label_value dyna-form">
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.maxRent && searchFilters.Criteria.maxRent !== "") ?
                                searchFilters.Criteria.maxRent : "Max Rent"}
                            </span>
                            <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        {getDDFilterOptions(searchConfig, 'maxRent', 'PropertyDetails')}
                    </UncontrolledButtonDropdown>
                </div>
            </span>
        </div>
    </>

    const bedsBathsDropdowns = () => <>
        <div className="filter_mincontrol">
            <span className="label_value dyna-form">
                <div className="text-label">Beds</div>
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.minBeds && searchFilters.Criteria.minBeds !== "") ?
                                searchFilters.Criteria.minBeds + '+ Beds' : 'Min Beds'}
                            </span>
                            <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        <DropdownMenu>
                            {bedsBathsOptions.map((num, i) =>
                                <DropdownItem key={i} onClick={() => { handleFilterChange('minBeds', num, 'int'); }}>{num}</DropdownItem>
                            )}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>
            </span>
            <span className="label_text"></span>
            <span className="label_value dyna-form">
                <div className="text-label">Baths</div>
                <div>
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                        <span>{(searchFilters.Criteria && searchFilters.Criteria.minBaths && searchFilters.Criteria.minBaths !== "") ?
                            searchFilters.Criteria.minBaths + '+ Baths' : 'Min Baths'}
                        </span>
                        <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        <DropdownMenu>
                            {bedsBathsOptions.map((num, i) =>
                                <DropdownItem key={i} onClick={() => { handleFilterChange('minBaths', num, 'int'); }}>{num}</DropdownItem>
                            )}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>
            </span>
        </div>
    </>

    function showHideDropdown() {
        const isCommercial = searchFilters.Criteria && searchFilters.Criteria.propertyType && searchFilters.Criteria.propertyType.length === 1 && searchFilters.Criteria.propertyType.indexOf('Commercial') !== -1;
        const action = isCommercial ? commercialDropdowns() : forSaleDropdowns();
        return <>
            <div className="col-sm-6">
                {searchFilters.Criteria.forRent ? forRentDropdowns() : action}
            </div>
            <div className="col-sm-6">
                {bedsBathsDropdowns()}
            </div>
        </>
    }

    return <div className="dyna-popoverBody more-filters">
        <div className="row">
            <div className="col">
                <div className="listings-count mg-btm-8 ft-sz-16">{`${listings.totalCount} Results`}</div>
            </div>
        </div>

        <div className="row">
            <div className="col-sm-6">
                <div className="text-label">Listing Status</div>
                <div>
                    <Form>
                        <FormGroup className="mg-btm-24">
                            {/* getSingleSelectCheckBoxList(["For Sale","For Rent"],"transactionType", false) */}
                            <div className="icon_checkbox_list">
                                <CustomInput type="radio" id={"radForSale_SaleOrLease"} inline className="icon_checkbox size50"
                                    name={"SaleOrLease"} value={"forSale"}
                                    checked={(searchFilters.Criteria && searchFilters.Criteria.forSale) ? true : false}
                                    onChange={handleSaleOrLeaseChange}
                                    onFocus={(e) => e.currentTarget.parentElement.classList.add('with-focus')}
                                    onBlur={(e) => e.currentTarget.parentElement.classList.remove('with-focus')}
                                    label={(
                                        <div className="icon_checkbox_wrapper">
                                            <div className="chk_label">{"For Sale"}</div>
                                        </div>
                                    )}
                                />
                                <CustomInput type="radio" id={"radForRent_SaleOrLease"} inline className="icon_checkbox size50"
                                    name={"SaleOrLease"} value={"forRent"}
                                    checked={(searchFilters.Criteria && searchFilters.Criteria.forRent) ? true : false}
                                    onChange={handleSaleOrLeaseChange}
                                    onFocus={(e) => e.currentTarget.parentElement.classList.add('with-focus')}
                                    onBlur={(e) => e.currentTarget.parentElement.classList.remove('with-focus')}
                                    label={(
                                        <div className="icon_checkbox_wrapper">
                                            <div className="chk_label">{"For Rent"}</div>
                                        </div>
                                    )}
                                />
                            </div>
                        </FormGroup>
                    </Form>
                </div>
            </div>
            <div className="col-sm-6">
                <div className="text-label">Status</div>
                <div className="dyna-form">
                    <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                        <DropdownToggle caret size="sm">
                            <span>{(searchFilters.Criteria && searchFilters.Criteria.status && searchFilters.Criteria.status !== "") ? searchFilters.Criteria.status : "All"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                        </DropdownToggle>
                        {getDDFilterOptions(searchConfig, 'Status')}
                    </UncontrolledButtonDropdown>
                </div>
                {searchConfig['PropertyDetails'] && searchConfig['PropertyDetails'].find(o => o.Id === 'includePrivate') &&
                    <div className=" icon_checkbox_list" style={{ marginTop: "5px" }}>
                        <CustomInput type="checkbox" label="Include Private Listings"
                            id="chkIncludePrivate" name="includePrivate"
                            value={true}
                            checked={(searchFilters.Criteria && searchFilters.Criteria.includePrivate) ? true : false}
                            onChange={handleCheckBoxRadioChange} />
                        <PrivateListingPopover id="chkIncludePrivate" />
                    </div>
                }
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12">
                <div>
                    <Form>
                        <FormGroup className="mg-btm-24">
                            <Label className="text-label">Property Type</Label>
                            <Select
                                name="propertyType"
                                isMulti={true}
                                value={searchFilters.Criteria.propertyType ?
                                    searchFilters.Criteria.propertyType.map(o => ({ label: o, value: o })) : null}
                                options={propertyType.Options.map(o => ({ label: o, value: o }))}
                                onChange={onMultiSelectChange}
                            />
                        </FormGroup>
                    </Form>
                </div>
            </div>
        </div>
        {underLandscapeTablet && 
            <div className="row mg-btm-24">
                {showHideDropdown()}
            </div>
        }
        <div className="row mg-btm-24">
            <div className="col-sm-6">
                <div className="text-label">Square Feet</div>
                <div className="filter_mincontrol">
                    <span className="label_value dyna-form">
                        <div>
                            <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                                <DropdownToggle caret size="sm">
                                    <span>{(searchFilters.Criteria && searchFilters.Criteria.minSqft && searchFilters.Criteria.minSqft !== "") ? searchFilters.Criteria.minSqft : "No min"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                                </DropdownToggle>
                                {getDDFilterOptions(searchConfig, 'minSqft', 'PropertyDetails')}
                            </UncontrolledButtonDropdown>
                        </div>
                    </span>
                    <span className="label_text">to</span>
                    <span className="label_value dyna-form">
                        <div>
                            <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                                <DropdownToggle caret size="sm">
                                    <span>{(searchFilters.Criteria && searchFilters.Criteria.maxSqft && searchFilters.Criteria.maxSqft !== "") ? searchFilters.Criteria.maxSqft : "No max"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                                </DropdownToggle>
                                {getDDFilterOptions(searchConfig, 'maxSqft', 'PropertyDetails')}
                            </UncontrolledButtonDropdown>
                        </div>
                    </span>
                </div>
                <div className=" icon_checkbox_list" style={{ marginTop: "5px" }}>
                    <CustomInput type="checkbox" inline label="Include unknown square feet"
                        id="chkUnknownSF" name="includeUnknownSqft"
                        value={true}
                        checked={(searchFilters.Criteria && searchFilters.Criteria.includeUnknownSqft) ? true : false}
                        onChange={handleCheckBoxRadioChange} />
                </div>
            </div>
            <div className="col-sm-6">
                <div className="text-label">Lot Size</div>
                <div className="filter_mincontrol">
                    <span className="label_value dyna-form">
                        <div>
                            <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                                <DropdownToggle caret size="sm">
                                    <span>{(searchFilters.Criteria && searchFilters.Criteria.minLotSize && searchFilters.Criteria.minLotSize !== "") ? searchFilters.Criteria.minLotSize : "No min"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                                </DropdownToggle>
                                {getDDFilterOptions(searchConfig, 'minLotSize', 'PropertyDetails')}
                            </UncontrolledButtonDropdown>
                        </div>
                    </span>
                    <span className="label_text">to</span>
                    <span className="label_value dyna-form">
                        <div>
                            <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                                <DropdownToggle caret size="sm">
                                    <span>{(searchFilters.Criteria && searchFilters.Criteria.maxLotSize && searchFilters.Criteria.maxLotSize !== "") ? searchFilters.Criteria.maxLotSize : "No max"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                                </DropdownToggle>
                                {getDDFilterOptions(searchConfig, 'maxLotSize', 'PropertyDetails')}
                            </UncontrolledButtonDropdown>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div className="row mg-btm-24">
            <div className="col-sm-6">
                <div className="text-label">Closed Date</div>
                <div className="filter_mincontrol">
                    <span className="label_value">
                        <DatePickerInput selected={searchFilters?.Criteria?.minClosedDate ? new Date(searchFilters?.Criteria?.minClosedDate) : null} setSelected={(date) => handleFilterChange('minClosedDate', date?.getTime())} fromDate={new Date(0)} toDate={searchFilters?.Criteria?.maxClosedDate ? new Date(searchFilters?.Criteria?.maxClosedDate) : new Date()} />
                    </span>
                    <span className="label_text">to</span>
                    <span className="label_value">
                        <DatePickerInput selected={searchFilters?.Criteria?.maxClosedDate ? new Date(searchFilters?.Criteria?.maxClosedDate) : null} setSelected={(date) => handleFilterChange('maxClosedDate', date?.getTime())} fromDate={searchFilters?.Criteria?.minClosedDate ? new Date(searchFilters?.Criteria?.minClosedDate) : new Date(0)} toDate={new Date()} isEndOfDay />
                    </span>
                </div>
            </div>
            <div className="col-sm-6">
                <div className="text-label">Year Built</div>
                <div className="filter_mincontrol">
                    <span className="label_value dyna-form">
                        <div>
                            <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                                <DropdownToggle caret size="sm">
                                    <span>{(searchFilters.Criteria && searchFilters.Criteria.minYearBuilt && searchFilters.Criteria.minYearBuilt !== "") ? searchFilters.Criteria.minYearBuilt : "No min"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                                </DropdownToggle>
                                {getDDFilterOptions(searchConfig, 'minYearBuilt', 'PropertyDetails')}
                            </UncontrolledButtonDropdown>
                        </div>
                    </span>
                    <span className="label_text">to</span>
                    <span className="label_value dyna-form">
                        <div>
                            <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                                <DropdownToggle caret size="sm">
                                    <span>{(searchFilters.Criteria && searchFilters.Criteria.maxYearBuilt && searchFilters.Criteria.maxYearBuilt !== "") ? searchFilters.Criteria.maxYearBuilt : "No max"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                                </DropdownToggle>
                                {getDDFilterOptions(searchConfig, 'maxYearBuilt', 'PropertyDetails')}
                            </UncontrolledButtonDropdown>
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-6">
                <div className="text-label">Max HOA Fees</div>
                <div className="dyna-form">
                    <div>
                        <UncontrolledButtonDropdown className={'dyna-dropdown open'}>
                            <DropdownToggle caret size="sm">
                                <span>{(searchFilters.Criteria && searchFilters.Criteria.maxHOA && searchFilters.Criteria.maxHOA !== "") ? searchFilters.Criteria.maxHOA : "No max"}</span><img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
                            </DropdownToggle>
                            {getDDFilterOptions(searchConfig, 'maxHOA', 'PropertyDetails')}
                        </UncontrolledButtonDropdown>
                    </div>
                </div>
            </div>
            <div className="col-lg-6">
                <div>
                    <Form>
                        <FormGroup className="mg-btm-24">
                            <Label className="text-label">Parking/Garage Spaces</Label>
                            {getSingleSelectCheckBoxList(["", "1", "2", "3", "4", "5", "6"], "minParkingGarageSpaces", "+", "int")}
                        </FormGroup>
                    </Form>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-6">
                <div>
                    <Form>
                        <FormGroup className="mg-btm-24">
                            <Label className="text-label">Stories</Label>
                            {getSingleSelectCheckBoxList(["", "Single", "Multi"], "stories", "", "str")}
                        </FormGroup>
                    </Form>
                </div>
            </div>
            <div className="col-lg-6">
                <div>
                    <Form>
                        <FormGroup className="mg-btm-24">
                            <Label className="text-label">Pool</Label>
                            {getSingleSelectCheckBoxList(["", "Yes", "No"], "hasPool", "", "bool")}
                        </FormGroup>
                    </Form>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12">
                <div className="icon_checkbox_list">
                    <Form>
                        <FormGroup className="mg-btm-24">
                            <Label className="text-label d-block">Must Haves</Label>
                            {mustHaves.map((option, i) => {
                                return <CustomInput key={i} type="checkbox" inline
                                    label={option.DisplayLabel}
                                    id={option.Id}
                                    name={option.Id}
                                    value={true}
                                    checked={(searchFilters.Criteria && searchFilters.Criteria[option.Id]) ? true : false}
                                    onChange={handleCheckBoxRadioChange} />
                            })}
                        </FormGroup>
                    </Form>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12">
                <div className="text-label">Keywords</div>
                <div className="dyna-form">
                    <Input type="text" className="keyword-input" name="keywords" key={'keywords_' + resetSearch}
                        defaultValue={(searchFilters.Criteria &&
                            searchFilters.Criteria.keywords &&
                            searchFilters.Criteria.keywords.length > 0) ?
                            searchFilters.Criteria.keywords.join(',') : ""}
                        placeholder="e.g. office, fireplace, guest house, gym, elementary school, etc"
                        onKeyUp={(event) => { event.persist(); handleInputChange(event) }}
                    />
                </div>
            </div>
        </div>
    </div>
}

export default SearchFilters;